/*
 * @Description: 
 * @Version: 2.0
 * @Autor: 一诺(丘汉文)
 * @Date: 2021-01-05 10:01:22
 * @Author: 一诺(丘汉文)
 * @LastEditors: 一诺(丘汉文)
 */
//基本路由 
export default {
     'index': resolve => require(['../page/Index.vue'], resolve),
     'login': resolve => require(['../page/Login.vue'], resolve),
     'setting': resolve => require(['../page/Setting.vue'], resolve),
     'admin/lists/add': resolve => require(['../page/admin/lists/Add.vue'], resolve),
     'admin/lists/edit': resolve => require(['../page/admin/lists/Edit.vue'], resolve),
     'admin/lists/lists': resolve => require(['../page/admin/lists/Lists.vue'], resolve),
     'admin/log/lists': resolve => require(['../page/admin/log/lists.vue'], resolve),
     'admin/menu/edit': resolve => require(['../page/admin/menu/Edit.vue'], resolve),
     'admin/menu/lists': resolve => require(['../page/admin/menu/Lists.vue'], resolve),
     'admin/menu/admin/edit': resolve => require(['../page/admin/menu/admin/Edit.vue'], resolve),
     'admin/menu/admin/lists': resolve => require(['../page/admin/menu/admin/Lists.vue'], resolve),
     'admin/power/edit': resolve => require(['../page/admin/power/Edit.vue'], resolve),
     'admin/power/lists': resolve => require(['../page/admin/power/Lists.vue'], resolve),
     'admin/power/admin/edit': resolve => require(['../page/admin/power/admin/Edit.vue'], resolve),
     'admin/power/admin/lists': resolve => require(['../page/admin/power/admin/Lists.vue'], resolve),
     'admin/role/admin': resolve => require(['../page/admin/role/Admin.vue'], resolve),
     'admin/role/edit': resolve => require(['../page/admin/role/Edit.vue'], resolve),
     'admin/role/lists': resolve => require(['../page/admin/role/Lists.vue'], resolve),
     'article/classify/edit': resolve => require(['../page/article/classify/Edit.vue'], resolve),
     'article/classify/lists': resolve => require(['../page/article/classify/Lists.vue'], resolve),
     'article/label/edit': resolve => require(['../page/article/label/Edit.vue'], resolve),
     'article/label/lists': resolve => require(['../page/article/label/Lists.vue'], resolve),
     'article/lists/edit': resolve => require(['../page/article/lists/Edit.vue'], resolve),
     'article/lists/lists': resolve => require(['../page/article/lists/Lists.vue'], resolve),
     'course/comment': resolve => require(['../page/course/Comment.vue'], resolve),
     'course/edit': resolve => require(['../page/course/Edit.vue'], resolve),
     'course/lists': resolve => require(['../page/course/Lists.vue'], resolve),
     'course/category': resolve => require(['../page/course/category.vue'], resolve),
     'course/hour/edit': resolve => require(['../page/course/hour/Edit.vue'], resolve),
     'integral/edit': resolve => require(['../page/integral/Edit.vue'], resolve),
     'integral/lists': resolve => require(['../page/integral/Lists.vue'], resolve),
     'live/add': resolve => require(['../page/live/Add.vue'], resolve),
     'live/edit': resolve => require(['../page/live/Edit.vue'], resolve),
     'live/keyword': resolve => require(['../page/live/Keyword.vue'], resolve),
     'live/lists': resolve => require(['../page/live/Lists.vue'], resolve),
     'order/edit': resolve => require(['../page/order/Edit.vue'], resolve),
     'order/explain': resolve => require(['../page/order/Explain.vue'], resolve),
     'order/lists': resolve => require(['../page/order/Lists.vue'], resolve),
     'order/monthcard': resolve => require(['../page/order/MonthCard.vue'], resolve),
     'question/config': resolve => require(['../page/question/Config.vue'], resolve),
     'question/edit': resolve => require(['../page/question/Edit.vue'], resolve),
     'question/index': resolve => require(['../page/question/Index.vue'], resolve),
     'question/tags': resolve => require(['../page/question/Tags.vue'], resolve),
     'question/auditing/edit': resolve => require(['../page/question/auditing/Edit.vue'], resolve),
     'question/auditing/list': resolve => require(['../page/question/auditing/List.vue'], resolve),
     'question/classify/list': resolve => require(['../page/question/classify/List.vue'], resolve),
     'question/subject/edit': resolve => require(['../page/question/subject/Edit.vue'], resolve),
     'question/subject/list': resolve => require(['../page/question/subject/List.vue'], resolve),
     'setting/open': resolve => require(['../page/setting/Open.vue'], resolve),
     'setting/gk/open': resolve => require(['../page/setting/gongkao/Open.vue'], resolve),
     'statistic/outline': resolve => require(['../page/statistic/Outline.vue'], resolve),
     'system/config': resolve => require(['../page/system/Config.vue'], resolve),
     'system/home': resolve => require(['../page/system/Home.vue'], resolve),
     'system/home/edit': resolve => require(['../page/system/home/Edit.vue'], resolve),
     'system/home/list': resolve => require(['../page/system/home/List.vue'], resolve),
     'system/push/edit': resolve => require(['../page/system/push/Edit.vue'], resolve),
     'system/version/edit': resolve => require(['../page/system/version/Edit.vue'], resolve),
     'system/version/lists': resolve => require(['../page/system/version/Lists.vue'], resolve),
     'teacher/edit': resolve => require(['../page/teacher/Edit.vue'], resolve),
     'teacher/lists': resolve => require(['../page/teacher/Lists.vue'], resolve),
     'user/edit': resolve => require(['../page/user/Edit.vue'], resolve),
     'user/feedback': resolve => require(['../page/user/Feedback.vue'], resolve),
     'user/lists': resolve => require(['../page/user/Lists.vue'], resolve),
     'wheel/add': resolve => require(['../page/wheel/Add.vue'], resolve),
     'wheel/edit': resolve => require(['../page/wheel/Edit.vue'], resolve),
     'wheel/lists': resolve => require(['../page/wheel/Lists.vue'], resolve),
     'wheel/gk/add': resolve => require(['../page/wheel/gongkao/Add.vue'], resolve),
     'wheel/gk/edit': resolve => require(['../page/wheel/gongkao/Edit.vue'], resolve),
     'wheel/gk/lists': resolve => require(['../page/wheel/gongkao/Lists.vue'], resolve),
     'question/import/lists': resolve => require(['../page/question/import/Lists.vue'], resolve),
     'realinfo/realinfo': resolve => require(['../page/realinfo/realinfo.vue'], resolve),
     'realinfo/realinfodetail': resolve => require(['../page/realinfo/realinfodetail.vue'], resolve),
     'realinfo/addrealinfo': resolve => require(['../page/realinfo/addrealinfo.vue'], resolve),
     'course/class': resolve => require(['../page/course/class.vue'], resolve),
     'course/addclass': resolve => require(['../page/course/addclass.vue'], resolve),
     'course/classdetail': resolve => require(['../page/course/classdetail.vue'], resolve),
     'line/lineList': resolve => require(['../page/line/lineList.vue'], resolve),
     'line/addLine': resolve => require(['../page/line/addLine.vue'], resolve),
     'line/detailLine': resolve => require(['../page/line/detailLine.vue'], resolve),
     'line/danmu': resolve => require(['../page/line/danmu.vue'], resolve),
     'line/jinyan': resolve => require(['../page/line/jinyan.vue'], resolve),
     'course/littleClass': resolve => require(['../page/course/littleClass.vue'], resolve),
     'course/littleClass_detail': resolve => require(['../page/course/littleClass_detail.vue'], resolve),
     'course/littleClass_add': resolve => require(['../page/course/littleClass_add.vue'], resolve),
     'shopping/shoppingList': resolve => require(['../page/shopping/shoppingList.vue'], resolve),
     "shopping/productType" : resolve => require(['../page/shopping/productType.vue'], resolve),
     "shopping/shoppingDetails" : resolve => require(['../page/shopping/shoppingDetails.vue'], resolve),
     "shopping/shoppingAdd" : resolve => require(['../page/shopping/shoppingAdd.vue'], resolve),
     "shopping/shoppingOrder" : resolve => require(['../page/shopping/shoppingOrder.vue'], resolve),
     "shopping/shoppingOrderDetail" : resolve => require(['../page/shopping/shoppingOrderDetail.vue'], resolve),
     "shopping/shoppingRefund" : resolve => require(['../page/shopping/shoppingRefund.vue'], resolve),
     "shopping/shoppingRefundDetail" : resolve => require(['../page/shopping/shoppingRefundDetail.vue'], resolve),
     "video/videolist" : resolve => require(['../page/video/videolist.vue'], resolve),
     "video/videolistv2" : resolve => require(['../page/video/videolistv2.vue'], resolve),
     "video/addvideo" : resolve => require(['../page/video/addvideo.vue'], resolve),
     "video/editvideo" : resolve => require(['../page/video/editvideo.vue'], resolve),
     "log/loglist" : resolve => require(['../page/log/loglist.vue'], resolve),
     "course/throughtrain": resolve => require(['../page/course/zhitongche.vue'], resolve),
     "course/throughtrainDetai": resolve => require(['../page/course/zhitongcheDetails.vue'], resolve),
     "course/douyinclass": resolve => require(['../page/course/douyinclass.vue'], resolve),
     "course/douyinadd": resolve => require(['../page/course/douyinadd.vue'], resolve),
     "course/douyinclassdetails": resolve => require(['../page/course/douyinclassdetails.vue'], resolve),
     "order/invoicelist": resolve => require(['../page/order/fapiao.vue'], resolve),
     'question/banklist/edit': resolve => require(['../page/question/banklist/Edit.vue'], resolve),
     'question/banklist/bankcategory': resolve => require(['../page/question/banklist/bankcategory.vue'], resolve),  
     'question/banklist': resolve => require(['../page/question/banklist/list.vue'], resolve),  
     'question/ailist': resolve => require(['../page/question/banklist/ailist.vue'], resolve), 
     'question/import': resolve => require(['../page/question/banklist/questionimport.vue'], resolve),  
     'question/importdetails': resolve => require(['../page/question/banklist/quesitionimportdetails.vue'], resolve), 
     'setting/iossetting': resolve => require(['../page/setting/IosStting.vue'], resolve),
       //首页
      '/': resolve => require(['../page/Index.vue'], resolve)
}


// WEBPACK FOOTER //
// ./src/routes/base.js